module.exports = __webpack_public_path__ + "img/centro-imagenes-quilmes.729c636f.jpg";